<template>
  <sl-page title="二维码生成" class="">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="80">
      <FormItem label="数据" prop="pairs">
        <Input v-model="form.pairs" type="textarea" :autosize="{minRows: 5,maxRows: 8}" />
      </FormItem>
      <sl-detail-list label-width="70px" label-align="right">
        <sl-detail-list-item :label-style="{'paddingRight':'10px','color':'rgba(0, 0, 0, 0.85)'}" :colon="false" title="总数" :content="data.length"/>
      </sl-detail-list>
      <FormItem>
        <Button type="primary" @click="handleSubmit('form')">确定</Button>
      </FormItem>
    </Form>
    <div style="width:631mm;">
      <div id="qrcode" style="min-width:52.5mm;max-width:631mm;font-size:0;">
        <div style="box-sizing:border-box;padding:0 2mm;position:relative;width:52.5mm;height:29.7mm;display:inline-block;vertical-align:bottom;font-size:3.5mm;border:1px dashed #aaa;" v-for="item in data">
          <div style="position:relative;width:100%;height:100%">
            <div style="width:60%;position:absolute;left:0;display:flex;justify-content:middle;align-items:center;justify-content: center;height: 100%; text-align: center;">
              <div>
                <img style="width:20mm;height:20mm;" :src="item.qrcode">
                <p style="font-size:0.8em;text-align: center; color:#111;">{{item.imei}}</p>
              </div>
            </div>
            <div style="width:40%;position:absolute;left:60%;display:flex;justify-content:middle;align-items:center;justify-content: center;height: 100%;">
              <div>
                <p style="font-weight:500;font-size:1.1em;text-align: center;color:#111;margin-bottom:.2em;">车辆编号</p>
                <p style="font-weight:700;font-size:1.2em;text-align: center;color:#111;">{{item.carNo}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </sl-page>
</template>
<script>
import QRCode from 'qrcode'
import html2canvas from 'html2canvas'

export default {
  // left315 x top370  168x168
  data() {
    return {
      rules: {
        carNo: [{ required: true, message: '车辆编号不能为空', trigger: 'blur,change' }],
        imei: [{ required: true, message: 'IMEI不能为空', trigger: 'blur,change' }],
      },
      form: {
        carNo: 123456,
        imei: 123456,
        pairs: ''
      },
      html: '',
      src: null,
      loading: false,
      data: [],
      modalVisible: false,
    }
  },

  computed: {

  },

  watch: {
    'form.pairs'(val) {
      this.parse()

    }
  },
  mounted() {},

  methods: {
    init(id) {
      if (id) {
        this.$refs['form'].resetFields()
        this.form.carNo = id
        this.modalVisible = true
      }
    },
    parse() {
      let d = this.form.pairs.split(/[\r\n]/g)
      d = d.map(i => i.replace(/^\s+/, '').replace(/\s+$/, '').split(/\s+/)).map((i, j) => ({ index: j, carNo: i[0], imei: i[1] }))
      d = d.filter(i => (i.carNo && i.imei))

      let invalid = d.every(i => i.carNo && i.imei)
      if (invalid) {
        d.forEach(i => {
          QRCode.toString(i.imei, {
            margin: 0,
            width: 450,
            height: 450,
            color: {
              light: '#0000' // Transparent background
            }
          }, (err, data) => {
            if (err) throw err

            i.qrcode = 'data:image/svg+xml;base64,' + btoa(data)
            // this.saveToImage()
          })
        })

        this.data = d
      }

    },
    download(data, fileName = 'download.png') {
      var link = document.createElement('a')

      link.href = data
      link.download = fileName

      var evt = document.createEvent("MouseEvents")
      evt.initEvent("click", false, false);
      // link.click()
      link.dispatchEvent(evt);
    },
    saveToImage() {
      html2canvas(document.querySelector("#qrcode"), { backgroundColor: null }).then(canvas => {

        let type = 'png'; //设置下载图片的格式

        let imgData = canvas.toDataURL("image/png"); //将canvas保存为图片

        // imgData = imgData.replace('image/png','image/octet-stream');
        // this.src = imgData
        this.download(imgData)
      });
    },
    save() {
      this.saveToImage()


    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    }

  }
}

</script>
